export const cardColors = {
  white: {
    color: "#F9FAFB",
    stroke: "#CBD5E8",
    name: "white",
  },
  blue: {
    color: "#87D2FD",
    stroke: "#679FC0",
    name: "blue",
  },
  gray: {
    color: "#E1E1E2",
    stroke: "#ADADAD",
    name: "gray",
  },
  red: {
    color: "#F9A7A7",
    stroke: "#BE9B9B",
    name: "red",
  },
  green: {
    color: "#A9FFD9",
    stroke: "#8AC6AC",
    name: "green",
  },
  purple: {
    color: "#E1C5FF",
    stroke: "#A78FC1",
    name: "purple",
  },
  rose: {
    color: "#FFC2E5",
    stroke: "#C39AB1",
    name: "rose",
  },
} as const;
